import Head from "next/head"
import styles from "@/styles/corporate-culture.module.scss"
import DefaultLayout from "@/components/DefaultLayout"
import { useState, useEffect } from "react"
import Image from "next/image"
import { Divider, Image as AntImage } from 'antd';
import { Swiper, SwiperSlide } from 'swiper/react';
import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain
import LocaltionSvg from "@/svgs/location.svg"
import 'swiper/css'
import 'swiper/css/pagination'
import SwiperCore, { Autoplay } from 'swiper';
export default function CorporateCulture() {
  // 注册 Autoplay 模块
  SwiperCore.use([Autoplay]);
  const [currentCore, setCurrentCore] = useState(0)
  const [smallTabArray, setSmallTabArray] = useState([{
    id: 1,
    title: '态度',
    content: '用正面的态度面对工作与生活，用积极的行动去解决问题，成为一个正能量并且有影响力的人。'
  }, {
    id: 2,
    title: '能力',
    content: '出色地完成你的工作，持续优化、追求进步，永远不要成为拖后腿的人。'
  }, {
    id: 3,
    title: '潜力',
    content: '可以从零开始，可以从错误中成长，但一定要有清晰的目标并不断去尝试去突破。'
  }])
  const [smallTabActive, setSmallTabActive] = useState(1)

  const [schoolShowList, setSchoolShowList] = useState([{
    id: 1,
    title: '成长课堂',
    content: '各部门的内部成员轮流分享，打开认知边界，激发员工的分享欲',
    imageUrl: `${imageDomain}/corporate-culture/class/class1.png`
  }, {
    id: 2,
    title: '学习分享会',
    content: '每月1期分享，实现员工从20%输入到80%输出的自我突破平台',
    imageUrl: `${imageDomain}/corporate-culture/class/class2.png`
  }, {
    id: 3,
    title: '新人入职培训',
    content: '针对新员工的专项培训，帮助员工快速融入公司',
    imageUrl: `${imageDomain}/corporate-culture/class/class3.png`
  }, {
    id: 4,
    title: '专业培训',
    content: 'CS人的专业知识讲堂，从岗位技能出发，获取有用知识',
    imageUrl: `${imageDomain}/corporate-culture/class/class4.png`
  }, {
    id: 5,
    title: '管理培训',
    content: '提升管理者水平的研修班，积蓄发展力量，提升软实力',
    imageUrl: `${imageDomain}/corporate-culture/class/class5.png`
  }, {
    id: 6,
    title: '通用培训',
    content: '人人可参与的通用课程，夯实理论知识、提高实操技能',
    imageUrl: `${imageDomain}/corporate-culture/class/class6.png`
  }])


  const [workParkList, setWorkParkList] = useState([{
    id: 1,
    title: '广州海珠总部·408休闲室',
    content: '我们在这里促进员工交流，举办日常文化活动。休闲间隙，放松心情，为工作积蓄满满能量。你总能在休息区找到惊喜和灵感。',
    imageUrl: `${imageDomain}/corporate-culture/workplace-1.png`
  }, {
    id: 2,
    title: '创意园区写字楼',
    content: '总部坐落于海珠区杨协成电子创意园，地铁3号线、8号线双汇地铁站-客村。这是一座追求艺术和美，集智能与舒适为一体的园区。',
    imageUrl: `${imageDomain}/corporate-culture/workplace-2.png`
  }])

  const [activeList, setActiveList] = useState([{
    id: 1,
    title: '公益活动',
    imageUrl: `${imageDomain}/corporate-culture/active/public_benefit_activities_1.png`
  }, {
    id: 2,
    title: '节日活动',
    imageUrl: `${imageDomain}/corporate-culture/active/festival_activities.png`
  }, {
    id: 3,
    title: '年会&运动会',
    imageUrl: `${imageDomain}/corporate-culture/active/sport_1.png`
  }, {
    id: 4,
    title: '年会&运动会',
    imageUrl: `${imageDomain}/corporate-culture/active/sport_2.png`
  }, {
    id: 5,
    title: '游园会',
    imageUrl: `${imageDomain}/corporate-culture/active/sport_3.png`
  }, {
    id: 6,
    title: 'CS社团-羽毛球',
    imageUrl: `${imageDomain}/corporate-culture/active/badminton.png`
  }, {
    id: 7,
    title: 'CS社团-篮球',
    imageUrl: `${imageDomain}/corporate-culture/active/basketball.png`
  }, {
    id: 8,
    title: 'CS社团-瑜伽',
    imageUrl: `${imageDomain}/corporate-culture/active/yoga.png`
  }])

  const [isBeginning, setIsBeginning] = useState(true); // 默认开始在第一屏
  const [isEnd, setIsEnd] = useState(false);            // 默认不在最后一屏
  const [swiper, setSwiper]: any = useState(null);

  const [corporateResponsibilityList, setCorporateResponsibilityList] =
    useState([
      {
        id: 6,
        imageUrl: `${imageDomain}/corporate-culture/corporate-responsibility/charitable.png`,
      },
      {
        id: 1,
        imageUrl: `${imageDomain}/corporate-culture/corporate-responsibility/award.png`,
      },
      {
        id: 2,
        imageUrl: `${imageDomain}/corporate-culture/corporate-responsibility/2023.png`,
      },
      {
        id: 3,
        imageUrl: `${imageDomain}/corporate-culture/corporate-responsibility/2020.png`,
      },
      {
        id: 4,
        imageUrl: `${imageDomain}/corporate-culture/corporate-responsibility/2019.png`,
      },
      {
        id: 5,
        imageUrl: `${imageDomain}/corporate-culture/corporate-responsibility/2018.png`,
      },
    ]);

  const slidePrev = () => {
    swiper.slidePrev()
  }

  const slideNext = () => {
    swiper.slideNext()
  }

  return (
    <>
      <Head>
        <title>
          广州市杰钡利科技有限公司
        </title>

        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazysales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        />
        <meta
          name="description"
          content="Australia's #1 online shopping website! Cheap bargains & discounts with the top online shopping Australia store! From furniture, to toys & hobbies, to appliances & pet supplies -- we've got it all, with free shipping on selected items!"
        />
      </Head>

      <DefaultLayout>
        <div className={styles["page-corporate-culture"]}>
          <div className={styles["banner-box"]}>
            <AntImage
              className={styles['banner']}
              alt={'banner'}
              width={'100%'}
              style={{ minWidth: 1200 }}
              preview={false}
              src={`${imageDomain}/banner/company-culture.png`}
            />

            {/* <div className={styles['title-box']}>
              <div className={styles['sub-title']}>Company Culture</div>
              <div className={styles['title']}>企业文化</div>
            </div> */}
          </div>

          <div className={styles['content']}>
            <Image
              className={styles['content-bg']}
              alt={'content-bg'}
              width={1753}
              height={394}
              priority={true}
              src={`${imageDomain}/corporate-culture/company-culture-bg.png`}
            ></Image>

            <div className={styles['concept-development']}>
              <div className={styles['core-list']}>
                <div
                  className={`
                    ${styles['core-item']} 
                    ${currentCore == 0 ? styles['active'] : ''}
                  `}
                  style={{ backgroundImage: `url(${imageDomain}/corporate-culture/mission-bg.png)` }}
                  onMouseEnter={() => {
                    setCurrentCore(0)
                  }}
                >
                  <div className={styles['core-item-title']}>
                    <div className={styles['core-item-title-text']}>
                      使命·Mission
                    </div>
                    <div className={styles['icon-more']}>→</div>
                  </div>

                  <div className={styles['core-desc']}>打破世界信息差，<br />共享全球优质产品</div>
                  <div className={styles['core-english-desc']}>Bridge Global Information Gaps<br />Share High-Quality Products Worldwide</div>
                  <div className={styles['mask']}></div>
                </div>

                <div
                  className={`
                    ${styles['core-item']} 
                    ${currentCore == 1 ? styles['active'] : ''}
                  `}
                  style={{ marginLeft: '12px', backgroundImage: `url(${imageDomain}/corporate-culture/vision-bg.png)` }}
                  onMouseEnter={() => {
                    setCurrentCore(1)
                  }}
                >
                  <div className={styles['core-item-title']}>
                    <div className={styles['core-item-title-text']}>
                      愿景·Vision
                    </div>
                    <div className={styles['icon-more']}>→</div>
                  </div>

                  <div className={styles['core-desc']}>成为一家不断迭代、 <br />多元发展的全球化企业 </div>
                  <div className={styles['core-english-desc']}>To Become a Global Enterprise <br />with Continuous and Diversified <br />Development</div>
                  <div className={styles['mask']}></div>
                </div>
              </div>

              <div className={styles['english-title']}>Development Concept</div>
              <div className={styles['title']}>发展理念</div>
              <div className={styles['desc']}>·在大数据时代，掌握最核心的市场数据，快速预判市场趋势作出行动，带领团队深耕行业，把握市场带给我们的每一次机遇。<br />·重视人才，重视创新，持续孵化内部创业项目，实现人才的创业梦想。</div>

              <div className={styles['concept-list']}>
                <div className={styles['concept-item']}>
                  <Image
                    className={`${styles['item-bg']} ${styles['image-container']}`}
                    alt={'item-bg'}
                    width={384}
                    height={488}
                    src={`${imageDomain}/corporate-culture/break-information.png`}
                  ></Image>
                  <div className={styles['item-english-title']}>Bridge Global Information Gaps</div>
                  <div className={styles['item-title']}>打破信息差</div>
                </div>

                <div className={styles['concept-item']} style={{ margin: '0 20px' }}>
                  <Image
                    className={`${styles['item-bg']} ${styles['image-container']}`}
                    alt={'item-bg'}
                    width={384}
                    height={488}
                    src={`${imageDomain}/corporate-culture/realize-creation.png`}
                  ></Image>
                  <div className={styles['item-english-title']}>Achieve Co-creation</div>
                  <div className={styles['item-title']}>实现共创</div>
                </div>

                <div className={styles['concept-item']}>
                  <Image
                    className={`${styles['item-bg']} ${styles['image-container']}`}
                    alt={'item-bg'}
                    width={384}
                    height={488}
                    src={`${imageDomain}/corporate-culture/grab-chance.png`}
                  ></Image>
                  <div className={styles['item-english-title']}>Grab the Chance</div>
                  <div className={styles['item-title']}>把握机遇</div>
                </div>


              </div>


            </div>
          </div>

          <div
            className={styles['corporate-values']}
            style={{ backgroundImage: `url(${imageDomain}/corporate-culture/corporate-values-bg.png)` }}
          >
            <div className={styles['corporate-content']}>
              <div className={styles['corporate-english-title']}>Corporate Values</div>
              <div className={styles['corporate-title']}>企业价值观</div>

              <div className={styles['corporate-list']}>
                <div className={styles['corporate-item']}>
                  <div className={styles['corporate-item-title']}>创造力·Creativity</div>
                  <div className={styles['corporate-item-desc']}>·创造力=个人+组织共同创造的价值</div>
                  <div className={styles['corporate-item-desc']}>·自负盈亏的阿米巴思维</div>
                  <div className={styles['corporate-item-desc']}>·努力赚到你的工资无限增加你的收入</div>
                </div>

                <div className={`${styles['corporate-item']} ${styles['corporate-item-middle']}`}>
                  <div className={styles['corporate-item-title']}>输出力·Output Capacity</div>
                  <div className={styles['corporate-item-desc']}>·学习=20%的输入+80%的输出</div>
                  <div className={styles['corporate-item-desc']}>·重视学习输出</div>
                  <div className={styles['corporate-item-desc']}>·在实践中继续学习</div>
                  <div className={styles['corporate-item-desc']}>·用行动去改变结果</div>
                </div>

                <div className={styles['corporate-item']}>
                  <div className={styles['corporate-item-title']}>不设限·No Limit</div>
                  <div className={styles['corporate-item-desc']}>·不设限=动态的（眼光+思维+行动）</div>
                  <div className={styles['corporate-item-desc']}>·保持好奇</div>
                  <div className={styles['corporate-item-desc']}>·不自我设限善于发现和思考</div>
                  <div className={styles['corporate-item-desc']}>·敢于尝试和挑战</div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles['talen-vision']}>
            <div className={styles['max-width']} style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div className={styles['talen-vision-left']}>
                <div className={`${styles['talen-vision-left-title']} ${styles['second-title']}`}>
                  <div className={styles['language-english']}>Talent Vision</div>
                  <div className={styles['language-chinese']}>人才观</div>
                </div>
                <div className={styles['talen-vision-left-content']}>
                  杰钡利科技重视优秀人才的引进与培养，“态度、能力、潜力”作为企业选拔人才的标准，为员工提供全面的成长土壤，使其能力得以发展发挥，共同实现个人与组织的价值最大化。
                </div>
                <div className={styles['small-school']}>
                  <div className={styles['smallTab']}>
                    <div className={styles['smallTab-nav']}>
                      {
                        smallTabArray.map((tab: any) => (
                          <div
                            key={tab.key}
                            className={`${styles['smallTab-nav-item']} ${tab.id === smallTabActive ? styles['smallTab-nav-item-active'] : ''}`}
                            onClick={() => {
                              setSmallTabActive(tab.id)
                            }}
                          >{tab.title}</div>
                        ))
                      }
                    </div>
                    {
                      smallTabArray.map((tab: any) => {
                        if (tab.id !== smallTabActive) return
                        return (
                          <div key={tab.key} className={styles['smallTab-content']} >{tab.content}</div>
                        )
                      })
                    }
                  </div>
                </div>
              </div>
              <div className={styles['talen-vision-right']}>
                <AntImage className={`${styles['image-container']}`} src={`${imageDomain}/corporate-culture/many-people.png`} preview={{ mask: null }} width="100%" />
              </div>
            </div>
          </div>

          <div className={styles['talen-development']}>
            <div className={styles['max-width']}>
              <div className={styles['school-box']}>
                <div className={styles['school-main']} >
                  <div className={styles['small-school']} style={{ backgroundImage: `url('${imageDomain}/corporate-culture/small-school-background.png')` }}>
                    <div className={styles['second-title']}>
                      <div className={styles['language-english']}>Crazysales College</div>
                      <div className={styles['language-chinese']}>CS小学院</div>
                    </div>
                    <div className={styles['content']}>
                      以“态度、能力、潜力”的人才观为指引，我们设计了与专业和管理双通道职业发展路径相匹配的培训体系-CS小学院，为Crzaysales的现在和未来培养人才。
                    </div>
                  </div>
                  <div className={styles['small-school-image']}>
                    <AntImage className={`${styles['image-container']}`} src={`${imageDomain}/corporate-culture/class/class-school.png`} width="100%" preview={{ mask: null }} />
                  </div>
                </div>

                <div className={styles['school-list']}>
                  {
                    schoolShowList.map((item: any) => (
                      <div className={styles['school-list-item']} key={item.id}>
                        <AntImage src={item.imageUrl} width="100%" preview={false} />
                        <div className={styles['school-list-hover']}>
                          <div className={styles['school-list-hover-title']}>{item.title}</div>
                          <div className={styles['school-list-hover-content']}>{item.content}</div>
                        </div>
                      </div>
                    ))
                  }
                  <div className={styles['school-list-item']}></div>
                </div>
              </div>
            </div>

          </div>

          <div className={styles['workplace-environment']}>
            <div className={styles['second-title']}>
              <div className={styles['language-english']} style={{ paddingTop: '48px' }}>Workplace Environment</div>
              <div className={styles['language-chinese']}>办公环境</div>
            </div>
            <div className={styles['workplace-environment-list']}>
              {
                workParkList.map((item: any) => (
                  <div className={styles['workplace-environment-item']} key={item.id}>
                    <div style={{ overflow: 'hidden' }}>
                      <AntImage className={`${styles['image-container']}`} src={item.imageUrl} width="100%" preview={{ mask: null }} />
                    </div>
                    <div className={styles['workplace-environment-item-title']}><LocaltionSvg className={styles['localtionSvg']} />{item.title}</div>
                    <div className={styles['workplace-environment-item-content']}>{item.content}</div>
                  </div>
                ))
              }
            </div>
          </div>

          <div className={styles['humanistic-care']}>
            <div className={styles['humanistic-care-image']}>
              <div style={{ overflow: 'hidden' }}>
                <AntImage className={`${styles['image-container']}`} src={`${imageDomain}/corporate-culture/humanistic-care.png`} width="100%" preview={{ mask: null }} />
              </div>
            </div>
            <div className={styles['humanistic-care-content']}>
              <div className={styles['humanistic-care-content-left']}>员工福利</div>
              <div className={styles['humanistic-care-content-right']}>
                <div className={styles['humanistic-care-content-right-title']}>齐全多样的员工福利及健康关怀</div>
                <div className={styles['humanistic-care-content-right-desc']}>美味午餐、双休、弹性工作制、部门员工聚餐活动、五险一金、意外险、商业险、员工生日聚会、年度体检、运动社团、节日福利、年度旅游团建、带薪年假、婚假等，公司是你前进路上的坚实后盾。</div>
              </div>
              <div className={styles['words-bg']}>HUMANISTIC CARE</div>
            </div>
          </div>

          <div className={styles['employee-activities']}>
            <div className={styles['max-width']}>
              <div className={styles['second-title']}>
                <div className={styles['language-english']} style={{ paddingTop: '60px' }}>Employee Activities</div>
                <div className={styles['language-chinese']}>员工活动</div>
              </div>
              <div className={styles['employee-activities-desc']}>主题形式从来不重样，文化调性永远都在线，仪式感+诚意满满</div>
            </div>
            <div className={`${styles['employee-activities-list']}`}>
              <Swiper
                direction="horizontal"
                onSwiper={(swiper) => setSwiper(swiper)}
                slidesPerView={3}
                slidesPerGroup={3}
                spaceBetween={24}
                speed={1200}
                onSlideChange={(swiper) => {
                  // 滑动时更新状态
                  setIsBeginning(swiper.isBeginning);
                  setIsEnd(swiper.isEnd);
                }}
              >
                {
                  activeList.map((item: any) => (
                    <SwiperSlide key={item.id}>
                      <div className={styles['employee-activities-list-item']}>
                        <div style={{ overflow: 'hidden' }}>
                          <AntImage className={`${styles['image-container']}`} src={item.imageUrl} width="100%" preview={{ mask: null }} />
                        </div>
                        <div className={styles['employee-activities-list-item-title']}>{item.title}</div>
                      </div>
                    </SwiperSlide>
                  ))
                }
              </Swiper>
              {
                !isBeginning
                &&
                <div className={styles['swiper-wrapper-prev']} onClick={slidePrev}>
                  <AntImage
                    src={`${imageDomain}/corporate-culture/allow-left.png`}
                    alt={'banner'}
                    width="100%"
                    preview={false}
                  />
                </div>
              }
              {
                !isEnd
                &&
                <div className={styles['swiper-wrapper-next']} onClick={slideNext}>
                  <AntImage
                    src={`${imageDomain}/corporate-culture/allow-right.png`}
                    alt={'banner'}
                    width="100%"
                    preview={false}
                  />
                </div>
              }
            </div>
          </div>

          <div className={styles['corporate-responsibility']}>
            <div className={styles['max-width']} style={{ display: 'flex' }}>
              <div className={styles['corporate-responsibility-left']}>
                <div className={styles['second-title']}>
                  <div className={styles['language-english']}>Corporate Social Responsibility</div>
                  <div className={styles['language-chinese']}>社会责任</div>
                </div>
                <div className={styles['corporate-responsibility-left-desc']}>
                  杰钡利科技不断深化对企业社会责任的认知与行动，将社会责任根植于企业文化。我们秉承“用行动，播下爱的种子”的公益核心理念，积极鼓励和倡导员工参与社会公益活动，以实际行动回报社会。
                </div>
              </div>
              <div className={styles['corporate-responsibility-right']}>
                <Swiper
                  direction="horizontal"
                  speed={1200}
                  autoplay={{ delay: 300, disableOnInteraction: false, pauseOnMouseEnter: true }}
                  loop={true}
                >
                  {
                    corporateResponsibilityList.map((item: any) => (
                      <SwiperSlide key={item.id}>
                        <AntImage className={`${styles['image-container']}`} src={item.imageUrl} width="100%" preview={{ mask: null }} />
                      </SwiperSlide>
                    ))
                  }
                </Swiper>
              </div>
            </div>
          </div>

        </div>
      </DefaultLayout>
    </>
  )
}